import styles from "./Products.module.css";
import play from "../../../assets/play.svg";
import { products } from "../../../data/products";
import { useRef, useState } from "react";
import YoutubeVideoOverlay from "../YoutubeVideoOverlay/YoutubeVideoOverlay";

export default function Products() {
  return (
    <section className={styles.section}>
      <div className={styles.title}>Our Products</div>
      <div className={styles.cardContainer}>
        {products.map((product, index) => (
          <ProductCard
            title={product.title}
            key={index}
            description={product.description}
            formLink={product.formLink}
            image={product.image}
            cardClass={`card${index}`}
            youtubeVideoLink={product.youtubeVideoLink}
          />
        ))}
      </div>
      <div className={styles.text}>
        Many, many new business categories are on the way — stay tuned.
      </div>
    </section>
  );
}

function ProductCard({
  title,
  description,
  formLink,
  image,
  cardClass,
  youtubeVideoLink,
}) {
  const handleNavigation = (url) => {
    window.open(url, "_blank", "noopener, noreferrer");
  };

  const [videoLink, setVideoLink] = useState("");

  const ref = useRef();

  const handlePlayBtnClick = (link) => {
    setVideoLink(link);
    ref.current.openVideo();
  };

  return (
    <div className={`${styles.card} ${styles[cardClass]}`}>
      <div className={styles.title}>{title}</div>
      <div className={styles.description}>{description}</div>
      {formLink ? (
        <button
          onClick={() => handleNavigation(formLink)}
          className={styles.surveyBtn}
        >
          Take Survey
        </button>
      ) : (
        <button className={styles.comingSoonBtn}>Coming Soon</button>
      )}
      <div className={styles.previewContainer}>
        <img className={styles.previewImg} src={image} alt="" />
        <div
          className={styles.play}
          onClick={() => handlePlayBtnClick(youtubeVideoLink)}
        >
          <img src={play} alt="" />
        </div>
      </div>
      <YoutubeVideoOverlay ref={ref} videoLink={videoLink} />
    </div>
  );
}
